import React, { useState, useEffect, useCallback } from 'react';
import LVButtonAccion from '../Basicos/LVButtonAccion';
import { LVGridCarga } from '../Basicos/LVGridCarga';
import { Column } from "devextreme-react/data-grid";
import { DateBox, NumberBox, TextBox } from 'devextreme-react';
import ComboAbmImpImpuestosTipos_Retenciones from '../Compuestos/Combos/ComboAbmImpImpuestosTipos_Retenciones';
import ComboAbmImpImpuestosTiposCategorias from '../Compuestos/Combos/ComboAbmImpImpuestosTiposCategorias';

function LVSelectorRetencionesCompra({ onClose, onConfirm, ImporteTotal, Retenciones, onTotalImporteDelComponenteChange }) {
  const [codigoImpuestoTipo, setCodigoImpuestoTipo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [comprobante, setComprobante] = useState("");
  const [categoria, setCategoria] = useState("");
  const [porcentaje, setPorcentaje] = useState(0);
  const [importe, setImporte] = useState(0);
  const [contadorId, setContadorId] = useState(0);

  const [data, setData] = useState(Retenciones)

  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { VEN: { function_VEN_OperacionesDeCompra } } = require('neftis7_apicaller');

  const customizeTotal = useCallback((e) => {
    if (e.value) {
      const formattedValue = e.value;
      onTotalImporteDelComponenteChange(e.value);
      return `T: ${formattedValue}`;
    }
  }, []);

  const Totalizador = () => {
    let totalNeto = 0;

    data.forEach(row => {
      totalNeto += row.Importe || 0;
    });

    onTotalImporteDelComponenteChange(totalNeto);
  }

  const handleConfirm = () => {
    onConfirm(data);
  };

  const handleOnRowUpdatedLocal = (e) => {
    const updatedRow = e.data;

    // Actualiza el estado del dataSource
    const updatedDataSource = [...data];
    const rowIndex = updatedDataSource.findIndex(row => row.id === updatedRow.id);
    if (rowIndex !== -1) {
      updatedDataSource[rowIndex] = updatedRow;
      setData(updatedDataSource);
    } else {
      setData(data)
    }
  }

  const handleCancel = () => {
    onClose();
  };

  const handleOnClick_Agregar = () => {
    const nuevoRegistro = {
      id: contadorId,
      CodigoImpuestoTipo: codigoImpuestoTipo,
      Descripcion: descripcion,
      Comprobante: comprobante,
      Importe: importe,
      Porcentaje: porcentaje,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
      CodigoPlanta: localStorage.getItem("CodigoPlanta")
    };

    setData(prevData => [...prevData, nuevoRegistro]); // Agrega el nuevo registro a la variable `data`

    setContadorId(contadorId + 1);
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    setImporte(porcentaje * ImporteTotal / 100);
  }, [porcentaje]);

  useEffect(() => {
    Totalizador()
  }, [data]);

  return (

    <div className='dx-theme-accent-as-background-color' style={{ padding: '20px', border: '1px solid #26e9ce', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>

      <table>
        <tbody>
          <tr>
            <td colSpan={3} align='center' >
              <h3>RetencionES DE Compra - IMPORTE TOTAL ${ImporteTotal}</h3>
            </td>
          </tr>

          <tr height='20'>
            <td colSpan={3} align='center' >

            </td>
          </tr>

          <tr>
            <td align='right' colSpan={3} >
              <div className='LV-FlexContainer' style={{ display: "flex", alignItems: "center", gap: '20px' }} >
                <ComboAbmImpImpuestosTipos_Retenciones
                  value={codigoImpuestoTipo}
                  onValueChanged={(e) => {
                    setCodigoImpuestoTipo(e.value);
                    setDescripcion(e.component.option("text"));
                    setComprobante("");
                    setImporte("");
                    setCategoria("");
                    setPorcentaje(0);
                  }}
                  ancho='300px' />
                <ComboAbmImpImpuestosTiposCategorias
                  CodigoImpuestoTipo={codigoImpuestoTipo}
                  onValueChanged={(e) => {
                    setCategoria(e.value);
                    setPorcentaje(e.component.option("text"));
                  }}
                  ancho='200px' />

                <TextBox
                  id="txtComprobante"
                  value={comprobante}
                  width={100}
                  onValueChanged={(e) => { setComprobante(e.value); }}
                  label="Comprobante" />
                <NumberBox
                  id="txtPorcentaje"
                  value={porcentaje}
                  width={100}
                  format="#,##0.##"
                  onValueChanged={(e) => { setPorcentaje(e.value); }}
                  label="Porcentaje" />
                <NumberBox
                  id="txtImporte"
                  value={importe}
                  width={100}
                  format="$ #,##0.##"
                  onValueChanged={(e) => { setImporte(e.value); }}
                  label="Importe" />
                <LVButtonAccion className='dx-theme-background-color' onClick={handleOnClick_Agregar} Texto="AGREGAR" />
              </div>
            </td>
          </tr>

          <tr height='20'>
            <td colSpan={3} align='center' >

            </td>
          </tr>
          <tr>
            <td colSpan={3}>

              <LVGridCarga
                dataSource={data}
                id="gridContainer"
                keyExpr="id"
                onRowUpdated={handleOnRowUpdatedLocal}
                onRowRemoved={handleOnRowUpdatedLocal}
              >
                <Column caption="Orden" dataField="id" width="70" alignment="Right" dataType="number" />
                <Column caption="Código" dataField="CodigoImpuestoTipo" width="80" alignment="Right" dataType="number" />
                <Column caption="Impuesto" dataField="Descripcion" width="100%" minWidth={200} alignment="Left" dataType="string" />
                <Column caption="Comprobante" dataField="Comprobante" width="100%" minWidth={200} alignment="Left" dataType="string" />

                <Column caption="Importe" dataField="Importe" width="120" alignment="Right" dataType="number" format="currency" />
                <Column caption="Porcentaje" dataField="Porcentaje" width="120" alignment="Right" dataType="number" />

              </LVGridCarga>
            </td>
          </tr>
          <tr style={{ height: '30px' }} />
          <tr>
            <td><LVButtonAccion className='dx-theme-background-color' onClick={handleConfirm} Texto="CONFIRMAR" /></td>
            <td width={10}></td>
            <td align='right'><LVButtonAccion className='dx-theme-background-color' onClick={handleCancel} Texto="CANCELAR" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorRetencionesCompra;